import { useState } from "react";

import AddCircleIcon from "@mui/icons-material/AddCircleRounded";
import { Box, Button, Checkbox, Divider, FormControlLabel, List, Stack, Typography } from "@mui/material";

import { AmbulanzCreationDialog } from "@/common/components/ambulanzes/ambulanz-creation/AmbulanzCreationDialog";
import { AmbulanzWidget } from "@/common/components/ambulanzes/ambulanz-widget/AmbulanzWidget";
import { useTranslation } from "@/translations";

import { useAmbulanzesQuery } from "./hooks/useAmbulanzesQuery";

export function Ambulanzes() {
  const { t } = useTranslation();

  const [showCompleted, setShowCompleted] = useState(false);

  const { data } = useAmbulanzesQuery(showCompleted);
  const open = data?.open ?? [];
  const completed = data?.completed ?? [];

  const [showCreationDialog, setShowCreationDialog] = useState(false);

  return (
    <Stack spacing={2} sx={{ height: "100%" }} pb={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
        <Typography variant="h1">{t("ambulanzes.title", { count: data?.openCount ?? 0 })}</Typography>
        <Stack direction="row" spacing={2} alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                checked={showCompleted}
                onChange={(_, checked) => setShowCompleted(checked)}
                aria-label={t("ambulanzes.showCompleted")}
              />
            }
            label={t("ambulanzes.showCompleted")}
          />
          <Button variant="contained" startIcon={<AddCircleIcon />} onClick={() => setShowCreationDialog(true)}>
            {t("ambulanzes.create")}
          </Button>
        </Stack>
        {showCreationDialog && <AmbulanzCreationDialog onClose={() => setShowCreationDialog(false)} />}
      </Box>

      <Stack sx={{ flex: 1, minHeight: 0 }} spacing={4}>
        <List disablePadding sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
          {open.map((ambulanz) => (
            <AmbulanzWidget key={ambulanz.ambulanzId} ambulanz={ambulanz} />
          ))}
        </List>

        {showCompleted && (
          <Stack sx={{ flex: 1, minHeight: 0 }}>
            <Typography variant="subtitle1" fontWeight={700} mb={1.5} mx={2}>
              {t("ambulanzes.completed", { count: completed.length })}
            </Typography>
            <Divider sx={{ mr: 2 }} />
            <List disablePadding sx={{ overflowY: "auto", flex: 1 }}>
              {completed.map((ambulanz) => (
                <AmbulanzWidget key={ambulanz.ambulanzId} ambulanz={ambulanz} />
              ))}
            </List>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
